// extracted by css-extract-rspack-plugin
var _1 = "WhatsNewLink-m_badgeNew-SeIl6ODU";
var _2 = "WhatsNewLink-m_upgrade-OsRTv80k";
export { _1 as "badgeNew", _2 as "upgrade" }
